@let isTablet = isTablet$ | async;

<div class="benefits" [id]="benefitsId">
  <div class="benefits__container">
    <div class="benefits__title" data-aos="fade-up">
      <h2 class="benefits__title_text">
        <span class="gradient-span">Riddick's Partners</span>
        <span> {{ 'benefits.unites' | translate }} </span>
        <span class="gradient-span">{{ 'benefits.webmastersAndAdvertisers' | translate }}</span>
        <span> {{ 'benefits.throughPowerful' | translate }}</span>
        <span class="gradient-span"> {{ 'benefits.advantages' | translate }}</span>
      </h2>
      <p class="headline-regular">{{ 'benefits.transformingOpportunities' | translate }}</p>
    </div>

    <div class="benefits__layout-grid" data-aos="fade-up">
      @for (benefit of benefits; track $index) {
        <div class="benefits__feature-card">
          <div class="benefits__feature-line"></div>

          <div class="benefits__heading">
            <div class="benefits__heading_container">
              <div class="benefits__heading_title">
                {{ benefit.title | translate }}
              </div>
              <div class="benefits__heading_description">
                {{ benefit.description | translate }}
              </div>
            </div>
          </div>

          <div class="benefits__blocks">
            <div class="benefits__blocks_container">
              @for (rows of benefit.rows; track $index; let i = $index) {
                <div
                  class="benefits__blocks_grid"
                  [ngClass]="{ 'benefits__blocks_grid-top': i === 0, 'benefits__blocks_grid-bottom': i === 1 }"
                >
                  @for (schema of rows | sortSchemas: isTablet; track $index) {
                    <a href="" class="benefits__blocks_item">
                      <div class="benefits__blocks_schemas-row">
                        <div class="benefits__blocks_icon">
                          <img src="assets/icons/benefits/{{ schema.icon }}.svg" alt="" />
                        </div>
                        <p class="benefits__blocks_title">
                          @for (title of schema.title; track $index) {
                            {{ title | translate }}
                            <br />
                          }
                        </p>
                      </div>
                    </a>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
